module.exports = __webpack_public_path__ + "img/sad-ticket.4d0fea3b.svg";